<mat-toolbar id="page" class="full-flex">
      <p>© 2020 RECEIPTIUM. All rights reserved.</p>
</mat-toolbar>
